// extracted by mini-css-extract-plugin
export default {"SocialMenu":"SocialMenu-module-ce01186234773b32e684","web":"SocialMenu-module-bb228e3e88b9decc788c"};